<template>
<div class="weather-wrapper">
  <div class="weather flex justify-start items-center">
    <i :class="{
      'el-icon-sunny': detail.day.weather === '晴',
      'el-icon-cloudy-and-sunny': detail.day.weather === '多云',
      'el-icon-heavy-rain': detail.day.weather === '暴雨',
      'el-icon-rain': detail.day.weather === '大雨',
      'el-icon-partly-cloudy': detail.day.weather === '阴',
      'el-icon-wind-power': detail.day.weather === '阵雨',
    }"></i>
    <div class="text">
      {{ `${detail.day.weather},${detail.night.temperature}-${detail.day.temperature}℃` }}
    </div>
    <el-divider direction="vertical"></el-divider>
    <div class="welcome">{{ welcome }}</div>
  </div>
</div>
</template>
<script>
import request from '@/plugin/axios';
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      url: '/platform/tencent/map/weather',
      detail: {},
      welcome: '',
    };
  },
  mounted(){
    this.init()
  },
  methods: {
    init(){
      request({
        url: this.url,
        method: 'get'
      }).then((res)=>{
        console.log("res=>", res)
        if(res.code == 0){
          this.detail = res.data;
          this.welcome = this.getTimeOfDay();
        }
      })
    },
    getTimeOfDay(){
      const date = new Date();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const totalMinutes = hour * 60 + minute; // 将时间转换为分钟数
      if (totalMinutes >= 1140 || totalMinutes < 300) { // 19:00-24:00 或 00:00-5:00
        return "晚上好，星光闪烁，卸下疲惫，拥抱美好！";
      } else if (totalMinutes >= 300 && totalMinutes < 420) { // 5:00-7:00
        return "早上好，新的一天即将开启。";
      } else if (totalMinutes >= 420 && totalMinutes < 690) { // 7:00-11:30
        return "上午好，阳光正好，活力满满，开启美好一天！";
      } else if (totalMinutes >= 690 && totalMinutes < 780) { // 11:30-13:00
        return "中午好，稍作休息，补充能量，午后更精彩！";
      } else if (totalMinutes >= 780 && totalMinutes < 1020) { // 13:00-17:00
        return "下午好，专注当下，收获满满，加油哦！";
      } else if (totalMinutes >= 1020 && totalMinutes < 1140) { // 17:00-19:00
        return "傍晚好，夕阳温柔，身心惬意，专注此刻！";
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.weather-wrapper {
  .weather {
    .text {
      font-size:12px; margin-left:6px;
    }
  }
  .welcome {
    font-size:12px; color:#666;
  }
}
</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-weather/index.vue"
}
</vue-filename-injector>
